<template>
  <v-container fluid>
    <v-skeleton-loader
      :loading="loading"
      type="table"
    >
      <!-- Content after loading goes here -->
      <v-data-table
        :headers="medlemsheaders"
        :items="medlemmer"
        :items-per-page="1000"
        :loading="loading"
        class="elevation-1"
      >
      <template v-slot:[`item.id`]="{ item }">
        <router-link :to="`/medlemsdata/${item.id}`">{{ item.id }}</router-link>
      </template>
      <template v-slot:[`item.active`]="{ item }">
        <v-simple-checkbox v-model="item.active" disabled></v-simple-checkbox>
      </template>
      <template v-slot:[`item.nyhedsbrev`]="{ item }">
        <v-simple-checkbox v-model="item.nyhedsbrev" disabled></v-simple-checkbox>
      </template>
      </v-data-table>
    </v-skeleton-loader>
    <br/>
    <v-btn color="primary" @click="download">Download til Excel</v-btn>
  </v-container>
</template>

<script>

import MedlemsService from '@/services/MedlemsService'

export default {
  name: 'MedlemsListe',

  data: () => ({
    loading: true,
    medlemsheaders: [
      {
        text: 'Medlemsnummer',
        align: 'start',
        value: 'id'
      },
      {
        text: 'Medlem siden',
        value: 'createdAt'
      },
      {
        text: 'Email',
        value: 'email'
      },
      {
        text: 'Navn',
        value: 'navn'
      },
      {
        text: 'Adresse',
        value: 'adresse'
      },
      {
        text: 'Postnr',
        value: 'postnummer'
      },
      {
        text: 'By',
        value: 'by'
      },
      {
        text: 'Telefon',
        value: 'telefon'
      },
      {
        text: 'Medlemstype',
        value: 'medlemstype'
      },
      {
        text: 'MobilePayAftale',
        value: 'mobilePayAgreementID'
      },
      {
        text: 'Nyhedsbrev',
        value: 'nyhedsbrev'
      },
      {
        text: 'Aktiv',
        value: 'active'
      },
      {
        text: 'Sidst betalt',
        value: 'lastPayment'
      }
    ],
    medlemmer: null,
    csvTest: null
  }),
  methods: {
    async download () {
      const medlemsdata = await MedlemsService.medlemsliste()
      this.csvTest = this.$papa.unparse(medlemsdata.data, {
        delimiter: ';',
        columns: ['id', 'createdAt', 'navn', 'email', 'adresse', 'postnummer', 'by', 'medlemstype', 'nyhedsbrev', 'active', 'mobilePayAgreementID']
      })
      this.$papa.download(this.csvTest, 'Medlemsdata')
    }
  },
  async mounted () {
    const medlemsdata = await MedlemsService.medlemsliste()
    this.medlemmer = medlemsdata.data
    this.loading = false
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
  color: inherit;
}
a:hover {
  text-decoration: underline;
}
</style>
